import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { CanalProducto } from '../_models/canal-producto';

@Injectable({
  providedIn: 'root'
})
export class CanalProductoService {
  private rutServicioCanalProducto = AppSettings.rutServiciosAPL + '/api/canalesProductos';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listadoCanalesProductos() {
    return this.httClient.get( this.rutServicioCanalProducto ).pipe( map( res => res as CanalProducto[] ) );
  }

  listadoCanalesProductosHabilitados() {
    return this.httClient.get( this.rutServicioCanalProducto + '/enabled' ).pipe( map( res => res as CanalProducto[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicioCanalProducto + '/' + id ).pipe( map( res => res as CanalProducto ) );
  }

  obtenerPorIdCanal( id: string ) {
    return this.httClient.get( this.rutServicioCanalProducto + '/canales/' + id ).pipe( map( res => res as CanalProducto[] ) );
  }

  crear( canalProducto: CanalProducto ) {
    canalProducto.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicioCanalProducto, canalProducto ).pipe( map( res => res as CanalProducto ) );
  }

  actualizar( canalProducto: CanalProducto ) {
    canalProducto.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicioCanalProducto, canalProducto ).pipe( map( res => res as any ) );
  }
}
